import { CheckboxMultipleOutlineIcon } from './CheckboxMultipleOutlineIcon';

/**
 * author: Michael Richins
 * id E0A0FF12-A5AD-40E3-B286-8958154F0537
 * name checkbox-multiple-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-outline.svg
 * tags
 * - Form 
 */
export const CheckBoxesOutlineIcon = CheckboxMultipleOutlineIcon;
export default CheckBoxesOutlineIcon